export default __webpack_public_path__ + "static/media/morocco8.b06936fd.jpg";